import { useQuery } from '@tanstack/react-query';

import { serviceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getServices: serviceTypes.GetServices = (params) => {
  return axios.get(`/services`, { params });
};

type QueryFnType = typeof getServices;

type UseGetServicesOptions = {
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetServices = ({ config = {}, department }: UseGetServicesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['services', department],
    enabled: !!department,
    queryFn: () => getServices({ department }),
  });
};
